// extracted by mini-css-extract-plugin
export default {"formHeading":"RG-z","form":"SG-z","submitBtn":"TG-z","disabled":"UG-z","input":"VG-z","error":"WG-z","submitMsg":"XG-z","signIn":"YG-z"};